import { useDispatch, useSelector } from "react-redux";
import "../../../../styles/screens/client-visit-details/manage-module/GetToKnowACList.css";
import Loader from "../../../common-components/Loader";
import { useEffect } from "react";
import ErrorAlert from "../../../common-components/ErrorAlert";
import ErrorMessages from "../../../../util/ErrorMessages";
import ACInfoCard from "../ACInfoCard";
import {
  getToKnowACData,
  resetErrorAlert,
  updateGetToKnowAC,
} from "../../../../slices/GetToKnowACSlice";
import { GetToKnowAC } from "../../../../util/Strings";
import BlackButton from "../../../custom-components/BlackButton";
import { useState } from "react";
import DraggableListAC from "../DraggableListAC";

function GetToKnowACList() {
  const data = useSelector((state) => state.ac.acData);
  const isLoading = useSelector((state) => state.ac.isLoading);
  const id = useSelector((state) => state.visits.selectedVisitId);
  const errorMessageCode = useSelector((state) => state.ac.errorCode);
  const [updatedSequence, setUpdatedSequence] = useState(data);
  const [showSorting, setSorting] = useState(false);

  const selectedOfficeId = useSelector(
    (state) => state.officelist.selectedOfficeId
  );
  const dispatch = useDispatch();

  function getAcData() {
    dispatch(getToKnowACData(selectedOfficeId));
  }

  function handleCloseErrorAlert() {
    dispatch(resetErrorAlert(false));
  }

  const handleListReorder = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      updatedSequence,
      result.source.index,
      result.destination.index
    );

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      dispatch(
        updateGetToKnowAC({ newData: { ...item, index: i }, id: item._id })
      );
    }
    setUpdatedSequence(items);
  };

  const onUpdateHandler = () => {
    if (showSorting) {
      let sequence = updatedSequence.map((item) => item._id);
    }
    setSorting(!showSorting);
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  useEffect(() => {
    getAcData();
  }, []);

  useEffect(() => {
    const orderedData = [...data].sort((a, b) => a?.index - b?.index);
    setUpdatedSequence(orderedData);
  }, [data]);

  if (isLoading) {
    return <Loader />;
  }
  if (errorMessageCode) {
    return (
      <ErrorAlert
        show={errorMessageCode}
        onClickHandle={handleCloseErrorAlert}
        title="Error"
        subTitle={ErrorMessages(errorMessageCode)}
      />
    );
  }

  return (
    <div className="get-to-know-ac-list-container">
      <div className="get-to-know-ac-list-heading">
        <div className="header-ac">
          {GetToKnowAC.getToKnowAC}
          {data?.length != 0 && (
            <BlackButton
              onClickhandle={onUpdateHandler}
              style={{ width: "80px" }}
            >
              {!showSorting ? "Update Order" : "Submit"}
            </BlackButton>
          )}
        </div>
      </div>
      <div className="get-to-know-ac-list-body">
        {!showSorting &&
          updatedSequence &&
          updatedSequence.map((item) => {
            return <ACInfoCard data={item} key={item._id} />;
          })}
      </div>
      <div className="get-to-know-ac-draggable-list">
        {showSorting && updatedSequence.length > 0 && (
          <DraggableListAC
            onDragEnd={handleListReorder}
            dataItems={updatedSequence}
          />
        )}
      </div>
    </div>
  );
}

export default GetToKnowACList;